import { createSlice } from '@reduxjs/toolkit';

const initialState = false;

/* istanbul ignore next */
const stickyPromoSlice = createSlice({
  initialState,
  name: 'stickyPromo',
  reducers: {
    setActiveMasterButton(_, action) {
      return action.payload;
    },
  },
  extraReducers: () => {},
});

export const {
  reducer: stickyPromoReducer,
  actions: { setActiveMasterButton },
} = stickyPromoSlice;
